export default "__VITE_ASSET__BetLJ5Ks__"